import React, {useEffect} from "react";
import {withRouter} from "react-router";
import {DemandValidation} from 'constants/DemandValidation';
import Offers from "components/complex/offer/Offers";
import StatisticsService from "services/StatisticsService";
import {connect} from "react-redux";
import DemandValidationMessages from "components/DemandValidationMessages";
import validateSection from "services/helpers/validateSection";

function OffersPanel(
    {
        match,
        demandValidation
    }) {
    const curDemandValidation = DemandValidation.OFFERS;
    const id = match.params.id;
    const section = demandValidation.find(x => x.section === curDemandValidation);
    const editable = section ? section.editable : false;

    useEffect(() => {
        StatisticsService.getCurrentRound(id);
        validateSection(curDemandValidation, id, false);
        return () => StatisticsService.clearCurrentRound();
    },[curDemandValidation, id])

    return (
        <div style={{width: '100%'}}>
            <DemandValidationMessages section={section} editable={editable} />
            <Offers
                demandId={id}
                downloadOffersEnabled
                registerEnvelopeEnabled={editable}
            />
        </div>
    )
}


export default connect((state) => ({
    demandValidation: state.resources.demandValidation,
}), {})(withRouter(OffersPanel));